import React, { useEffect, useState } from "react";
import "../style/checkout.css";
import Breadcrumb from "../../../Component/breadcrumb/Breadcrumb";
import { Button } from "react-bootstrap";
import DeliveryInformation from "../../../Component/Common/DeliveryInformation";
import { gettransporters } from "../service/transporters.service";
import { useDispatch, useSelector } from "react-redux";
import { fetchSummary } from "../redux/summarySlice";
import { useParams, useNavigate } from "react-router-dom";
import { orderPlace } from "../service/orderPlace.service";
import { Toaster, toast } from "react-hot-toast";
import { setCartCount } from "../../Cart/redux/cartSlice";

function CheckoutSummary() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cart_temp_token } = useParams();
  const checkoutId = cart_temp_token;
  const [transporters, setTransporters] = useState([]);
  const [deliveryInfo, setDeliveryInfo] = useState({
    transporter_id: null,
  });
  const [remarks, setRemarks] = useState("");
  const [placingOrder, setPlacingOrder] = useState(false);
  const { summary, loading } = useSelector(
    (state) => state.summary
  );
  const checkoutSummary =
    summary?.checkout_summary || {};
  const items =
    summary?.checkout_items || [];
  const customer =
    summary?.cart_customers?.[0] || {};
  const shipping =
    customer?.shippings?.[0] || {};

  // =========================================
  // GET SUMMARY
  // =========================================

  useEffect(() => {
    const loadSummary = async () => {
      if (!checkoutId) {
        navigate("/cart", { replace: true });
        return;
      }

      try {
        const result = await dispatch(
          fetchSummary(checkoutId)
        );

        if (fetchSummary.rejected.match(result)) {
          navigate("/cart", { replace: true });
          return;
        }

        const responseData = result.payload;

        if (
          !responseData ||
          responseData?.success === false
        ) {
          navigate("/cart", { replace: true });
          return;
        }

        await loadTransporters();

      } catch (error) {
        console.error(
          "Summary Error:",
          error
        );

        navigate("/cart", { replace: true });
      }
    };

    loadSummary();
  }, [dispatch, checkoutId, navigate]);

  // =========================================
  // TRANSPORTER API
  // =========================================

  const loadTransporters = async () => {
    try {
      const res = await gettransporters();

      setTransporters(
        res?.data || []
      );
    } catch (error) {
      console.log(
        "Transporter Error",
        error
      );
    }
  };

  // =========================================
  // CLEAR CART AFTER ORDER
  // =========================================

  const clearCartAfterOrder = () => {
    dispatch(setCartCount(0));
    localStorage.removeItem("cartItems");
    localStorage.removeItem("cartSummary");
    localStorage.removeItem("cart_count");
  };

  // =========================================
  // ORDER PLACE
  // =========================================

  const handleOrderPlace = async () => {
    if (placingOrder) {
      return;
    }

    // if (!deliveryInfo.transporter_id) {
    //   toast.error("Please select transporter");
    //   return;
    // }

    if (!checkoutId) {
      toast.error("Validate Checkout not found");
      return;
    }

    try {
      setPlacingOrder(true);

      const payload = {
        transporter_id: Number(deliveryInfo.transporter_id ?? 0),
        remarks: remarks?.trim() || "N/A",
      };

      const response = await orderPlace(
        checkoutId,
        payload
      );
      
      if (response) {
        clearCartAfterOrder();
      }

      // toast.success(
      //   response?.message ||
      //     "Order placed successfully"
      // );
      toast.success("🎉 Order Placed Successfully!");

      // =========================================
      // ORDER SUCCESS PAGE
      // =========================================

      setTimeout(() => {
        navigate(
          `/checkout/${encodeURIComponent(
            checkoutId
          )}/order-success`,
          {
            state: {
              orderResponse: response,
            },
          }
        );
      }, 500);

    } catch (error) {
      console.error(
        "Order Place Error:",
        error
      );
      toast.error("Something went wrong. Failed to place the order.");
      // toast.error(
      //   error?.response?.data?.message ||
      //     error?.message ||
      //     "Order place failed"
      // );

      setPlacingOrder(false);
    }
  };

  // =========================================
  // LOADING
  // =========================================

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <h4>Loading Checkout Summary...</h4>
      </div>
    );
  }

  // =========================================
  // NO TOKEN
  // =========================================

  if (!checkoutId) {
    return (
      <div className="container py-5 text-center">
        <h4>
          Checkout token not found
        </h4>
      </div>
    );
  }

  // =========================================
  // BREADCRUMB
  // =========================================

  const breadcrumbData = [
    {
      name: "Cart",
      path: "/cart",
    },
    {
      name: "Checkout",
      path: `/checkout/${checkoutId}/summary`,
    },
  ];

  return (
    <>
      <Toaster position="top-right" />

      <Breadcrumb
        items={breadcrumbData}
      />

      <div className="TableBoxCheckout">
        <div className="container">
          <div className="row">

            {/* LEFT SIDE */}
            <div className="col-md-9">
              <div className="summary-box">

                <div className="row">

                  {/* CUSTOMER */}
                  <div className="col-md-6">
                    <div className="checkout-card p-2">

                      <div className="card-title d-flex align-items-center mb-2" style={{ background:"#8080801a"}}>

                        <div className="icon-box">
                          <i className="bi bi-person"></i>
                        </div>

                        <h3 className="ms-3">
                          Billing Address
                        </h3>
                      </div>

                      {customer &&
                      Object.keys(customer).length > 0 ? (
                        <div className="customer-info">
                         <span className="fontsioze-13">  
                          <strong className="P-text">
                            {customer.customer_name || "-"}
                          </strong>
                        </span>
                        <p>
                           <i className="bi bi-geo-alt"></i>{" "}
                            Address :{" "}
                          {shipping?.address_line1 || "-"}, 
                          {shipping?.address_line2 || "-"},
                          <br/>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;City: {shipping?.city || "-"}, {shipping?.city || "-"},  Pincode: {shipping?.pincode || "-"}, India
                        </p>

                          <p>
                            <i className="bi bi-person"></i>{" "}
                            Contact Person :{" "}
                            {customer.contact_person || "-"}
                          </p>

                          <p>
                            <i className="bi bi-telephone"></i>{" "}
                            Mobile :{" "}
                            {customer.mobile || "-"}
                          </p>

                          <p>
                            <i className="bi bi-envelope"></i>{" "}
                            Email :{" "}
                            {customer.email || "-"}
                          </p>

                          <p>
                            <i className="bi bi-file-earmark-ruled"></i>{" "}
                            GST No :{" "}
                            {customer.gst_no || "-"}
                          </p>

                        </div>
                      ) : (
                        <p>
                          Customer data not found
                        </p>
                      )}

                    </div>
                  </div>

                  {/* SHIPPING */}
                  <div className="col-md-6">

                    <div className="p-2 checkout-card">

                      <div className="card-title d-flex align-items-center mb-3" style={{ background:"#8080801a"}}>

                        <div className="icon-box">
                          <i className="bi bi-geo-alt"></i>
                        </div>
                      
                        <h3 className="ms-3">
                          Shipping Address
                        </h3>

                      </div>

                      <div className="text-sm P-text">
                      <strong>
                            {customer.customer_name || "-"}
                          </strong>
                        <p>
                          Address :{" "}
                          {shipping?.address_line1 || "-"},
                          {shipping?.address_line2 || "-"}
                        </p>

                        <div className="billing">

                          <span>
                            City :{" "}
                            {shipping?.city || "-"},

                          </span>

                          <span>
                            State :{" "}
                            {shipping?.state || "-"}
                          </span>

                        </div>

                        <div className="billing">

                          <span>
                            Pincode :{" "}
                            {shipping?.pincode || "-"},
                            {shipping?.country || "INDIA"}
                          </span>

                        </div>

                      <div className="billing">

                          <span>
                            Mobile :{" "}
                            {shipping?.mobile || "-"}
                          </span>

                        </div>
                        

                      </div>
                      <hr/>
                         <DeliveryInformation
                        transporters={transporters}
                        value={
                          deliveryInfo?.transporter_id
                        }
                        onChange={(value) => {
                          setDeliveryInfo({
                            ...deliveryInfo,
                            transporter_id: value,
                          });
                        }}
                      />
                     

                      {/* <p>
                        Transporter
                      </p> */}


                    </div>
                  </div>

                  {/* ORDER DETAILS */}
                

                </div>

                {/* ITEMS TABLE */}
                <div className="row">

                  <div className="col-md-12">
                    <div className="p-2 checkout-card-table">
                      <div className="table-box-content">
                        <div className="table-responsive">
                         <table className="table table-lg table-boxrto checkoutcart-table">
                          <thead
                            className="text-center"
                            style={{ fontSize: "11px" }}
                           >
                            <tr>
                              <th width={70}>Image</th>
                              <th width={96}>Design Shade</th>
                              <th>Ord. Qty</th>
                              <th>GST (%)</th>
                              <th>Price/Unit</th>
                              <th>Disc./Unit</th>
                              <th>S. Price</th>
                              <th>Tax. Value</th>
                              <th>GST Amt.</th>
                              <th>Total</th>
                            </tr>
                          </thead>

                          <tbody>
                            {items?.length > 0 ? (
                              items.map((item) => (
                                <tr
                                  key={
                                    item.id ||
                                    item.cart_id ||
                                    item.product_listing_id
                                  }
                                >
                                  <td width={70} className="text-center">
                                    <img
                                      src={item.design_shade_image}
                                      width="50"
                                      alt={item.design_shade || "Product"}
                                      style={{
                                        margin: "0 auto",
                                        display: "block",
                                      }}
                                    />
                                  </td>

                                  <td width={96}>
                                    <strong>
                                      {item.quality_name}<br/>
                                      {item.design_shade || "-"}<br/>
                                      {item.size || "-"}
                                    </strong>
                                  </td>

                                  <td className="text-center">
                                    {item.quantity ?? 0}
                                  </td>

                                  <td className="text-right">
                                    {item.gst ?? 0}
                                  </td>

                                  <td className="text-right">
                                    {Number(item.mrp || 0).toLocaleString("en-IN")}
                                  </td>

                                  <td className="text-right">
                                    {Number(item.discount_amount || 0).toLocaleString(
                                      "en-IN"
                                    )}
                                  </td>

                                  <td className="text-right">
                                    {Number(item.selling_price || 0).toLocaleString(
                                      "en-IN"
                                    )}
                                  </td>

                                  <td className="text-right">
                                    {Number(item.taxable_amount || 0).toLocaleString(
                                      "en-IN"
                                    )}
                                  </td>

                                  <td className="text-right">
                                    {Number(item.gst_amount || 0).toLocaleString(
                                      "en-IN"
                                    )}
                                  </td>

                                  <td className="text-right">
                                    {Number(item.total_amount || 0).toLocaleString(
                                      "en-IN"
                                    )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={11} className="text-center">
                                  No checkout items found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            {/* RIGHT SUMMARY */}
            <div className="col-md-3">

              <div className="box-amount">

                <div className="d-flex align-items-center mb-1" style={{ background:"#8080801a"}}>

                  <div className="summary-icon">
                    <i className="bi bi-bag-check"></i>
                  </div>

                  <h6 className="mb-0 ms-3 fw-bold">
                    Order Summary
                  </h6>

                </div>

                <div className="d-flex justify-content-between mb-1">

                  <span>
                    Order Quantity
                  </span>

                  <strong
                    style={{
                      marginRight: "16px",
                    }}
                  >
                    {checkoutSummary?.total_quantity || 0}
                  </strong>

                </div>

                <div className="d-flex justify-content-between mb-1">

                  <span>
                    Taxable Value
                  </span>

                  <strong>
                    ₹{" "}
                    {Number(
                      checkoutSummary?.taxable_value || 0
                    ,2).toLocaleString("en-IN")}
                  </strong>

                </div>

                <div className="d-flex justify-content-between mb-1">

                  <span>
                    GST Amount
                  </span>

                  <strong>
                    ₹{" "}
                    {Number(
                      checkoutSummary?.gst_amount || 0
                    ,2).toLocaleString("en-IN")}
                  </strong>

                </div>

                <hr />

                <div className="d-flex justify-content-between align-items-center mb-3">

                  <h6 className="mb-0">
                    Total Amount
                  </h6>

                  <h6 className="mb-0 text-dark fw-bold">
                    ₹{" "}
                    {Number(
                      checkoutSummary?.total_amount || 0
                    ).toLocaleString("en-IN")}
                  </h6>

                </div>

                <hr />
                 <div className="mb-3">
                        <textarea
                          rows="4"
                          placeholder="Remark (Optional)"
                          className="form-control control-input"
                          value={remarks}
                          onChange={(e) =>
                            setRemarks(
                              e.target.value
                            )
                          }
                          style={{
                            height: "50px",
                            fontSize:"13px"
                          }}
                        />

                      </div>


               <Button
                  className="btn-order btn-lg w-100 shadow-sm"
                  onClick={handleOrderPlace}
                  disabled={placingOrder}
                >
                  {placingOrder ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      PLACING ORDER...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-lightning-charge-fill me-2"></i>
                      ORDER NOW
                    </>
                  )}
                </Button>


                <div className="secure-box mb-2 mt-2">
                  <div className="d-flex align-items-center">
                    <div className="secure-icon">
                      <i className="bi bi-shield-check"></i>
                    </div>
                    <div className="ms-2">
                      <h6 className="mb-1 text-success fw-bold"> Secure Business Checkout</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CheckoutSummary;